import { PaletteOptions } from '@mui/material/styles';

/**
 * Dark theme color palette for Yugen Frontend
 * Features luxury gold and bronze accents on dark backgrounds
 */
export const palette: PaletteOptions = {
  mode: 'dark',

  // Primary: Luxury Gold
  primary: {
    main: '#d4af37',      // Rich gold
    light: '#f0d98c',     // Light gold for hover states
    dark: '#b8941f',      // Deep gold for active states
    contrastText: '#0d0d0d',
  },

  // Secondary: Bronze
  secondary: {
    main: '#8b7355',      // Warm bronze
    light: '#a89176',     // Light bronze
    dark: '#6d5a42',      // Deep bronze
    contrastText: '#f5f5f5',
  },

  // Background colors
  background: {
    default: '#0d0d0d',   // Deep black background
    paper: '#1a1a1a',     // Slightly lighter for cards/surfaces
  },

  // Text colors
  text: {
    primary: '#f5f5f5',   // Almost white for primary text
    secondary: '#b0b0b0', // Medium gray for secondary text
    disabled: '#808080',  // Darker gray for disabled text
  },

  // Semantic colors
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f',
    contrastText: '#ffffff',
  },

  warning: {
    main: '#ff9800',
    light: '#ffb74d',
    dark: '#f57c00',
    contrastText: '#000000',
  },

  success: {
    main: '#4caf50',
    light: '#81c784',
    dark: '#388e3c',
    contrastText: '#ffffff',
  },

  info: {
    main: '#2196f3',
    light: '#64b5f6',
    dark: '#1976d2',
    contrastText: '#ffffff',
  },

  // Divider color
  divider: 'rgba(212, 175, 55, 0.12)', // Gold with low opacity
};
